import { render, staticRenderFns } from "./AppFilesUploader.vue?vue&type=template&id=705f3a50"
import script from "./AppFilesUploader.vue?vue&type=script&lang=js"
export * from "./AppFilesUploader.vue?vue&type=script&lang=js"
import style0 from "./AppFilesUploader.vue?vue&type=style&index=0&id=705f3a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports